<mat-paginator
  #paginator
  appearence="outline"
  sedsPaginatorNumber
  [attrs]="_props"
  [pageSizeOptions]="_props.pageSizeOptions!"
  [hidePageSize]="_props.hidePageSize"
  [showFirstLastButtons]="_props.showFirstLastButtons"
  [disabled]="_props.disabled">
</mat-paginator>
